import { createSlice } from '@reduxjs/toolkit'
import CollectiviteDto from 'rpqs/dto/CollectiviteDto'
import ManagementUnitDto from 'rpqs/dto/ManagementUnitDto'

export const initialState = {
    rpqs: {},
    rpqsList: [],
    collectivity: {},
    collectivities: [],
    managementUnit: {},
    managementUnits: [],
    citiesPopulations: [],
}

const store = createSlice({
    name: 'rpqs',
    initialState,
    reducers: {
        receiveRpqs: (state, action) => {
            state.rpqs = action.payload
        },
        receiveAllRpqs: (state, action) => {
            state.rpqsList = action.payload
        },
        receiveCollectivity: (state, action) => {
            state.collectivity = action.payload
        },
        receiveCollectivities: (state, action) => {
            state.collectivities = action.payload.map(p => new CollectiviteDto(p))
        },
        receiveManagementUnit: (state, action) => {
            state.managementUnit = action.payload
        },
        receiveManagementUnits: (state, action) => {
            state.managementUnits = action.payload.map(p => new ManagementUnitDto(p))
        },
        receiveCitiesPopulations: (state, action) => {
            state.citiesPopulations = action.payload
        },
    },
})

export const RpqsActionConstant = store.actions
export default store.reducer